<template>
<div class="Materials">
  <div class="page">
    <div class=" d-flex flex-column  pb-4 mb-4">
      <h1 class="font-lg py-6">Обучающие материалы</h1>
      <section
        class="d-flex flex-column w-100 gap-4 pt-4"
        v-if="!blocksIsEmpty"
      >
        <section
          v-for="block of blocks"
          :key="block.value"
          :class="[block.educations.length ? 'block' : 'd-none']"
        >
          <div
            v-if="block && block.educations.length"
          >
            <h3 class="title-block pb-5">{{block.title}}</h3>
            <div
              v-for="education of block.educations"
              :key="education.id"
              class="item-block d-flex w-100 justify-space-between gap-1 align-items-center pb-4"
            >
              <p class="pa-0 ma-0">
                {{education.title}}
              </p>
              <v-btn
                small
                class="background_transparent no-border"
                @click="goToDetailMaterial(education)"
              >
                <img src="@/assets/images/profile/arrowGo.svg" />
              </v-btn>
            </div>
          </div>
        </section>
      </section>
      <section v-else>
        <div class="empty-education">
          <div class="empty-illustration">
            <v-icon
              size="80px" color="grey-4"
            >mdi-school</v-icon>
          </div>

          <div class="empty-title">
            В данное время доступных обучающих материалов нет
          </div>

          <div class="empty-subtitle text-grey">
            ожидайте, скоро появятся
          </div>
        </div>

      </section>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

/**
 * Компонент: Materials
 * Описание:
 */
export default {
  name: 'Materials',

  components: {},

  props: {},

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      blocks: 'education/Education/educationBlocks',
      blocksIsEmpty: 'education/Education/educationBlocksIsEmpty',
    })
  },

  watch: {},

  created() {
  },

  async mounted() {
    await this.fetchAllEducation();
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      fetchEducations: 'education/Education/fetchAllEducation',
      fetchEducation: 'education/Education/fetchDetailEducation',
    }),

    ...mapMutations({}),
    async goToDetailMaterial(education) {
      await this.$router.push(`/training-materials/${education.id}`);
    },
    async fetchAllEducation() {
      await this.fetchEducations();
    },
  },
};
</script>

<style scoped lang="scss">
.Materials {
  /* Стили компонента */
  & .block{
    max-width: 700px;
    background: white;
    padding: 16px 24px;
    border-radius: 8px;
    & .title-block{
      font-size: 20px;
      color: var(--color-blue-500);
      font-weight: 600;
      letter-spacing: 0;
      padding: 9px 0;
    }
    & .item-block{
      font-size: 16px;
      color: var(--color-blue-500);
      font-weight: 600;
      letter-spacing: 0;
    }
  }
  & .v-btn{
    background: var(--color-blue-500);
    border-radius: 6px;
    font-size: 16px;
    padding: 10px 8px;
    ::v-deep span{
      line-height: 24px;
    }
    &.background_transparent{
      background: transparent;
      color: var(--color-blue-500)!important;
      &.no-border{
        border: none;
        box-shadow: none;
        color: var(--color-grey-500)!important;
        &:hover{
          box-shadow: none!important;
        }
      }
    }
  }
  & .empty-education {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
    text-align: center;

    .empty-illustration {
      margin-bottom: 24px;
      animation: float 3s ease-in-out infinite;
    }

    .empty-title {
      font-size: 1.2rem;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }

    .empty-subtitle {
      font-size: 1rem;
      margin-bottom: 24px;
    }
  }

  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
    100% { transform: translateY(0px); }
  }
}
</style>
